import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'communityPreview', [
  'RESET_COMMUNITY',
]);

export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'preview',
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;

  const defaultState = reqReducer(state, action);

  switch (type) {
    case consts.RESET_COMMUNITY: {
      return initialState;
    }
    default:
      return defaultState;
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/communityPreview.js